/* eslint-disable */
(function () {

  // Todos los campos cuyo required se gestiona condicionalmente
  var CAMPOS_CONDICIONALES = [
    'marca_moto',
    'cilindrada_moto',
    'modelo_vehiculo_no_listado',
    'cilindrada_vehiculo_no_listado',
    'potencia_fiscal_vehiculo_no_listado',
    'marca_coche',
    'modelo_coche',
    'tcombustible_coche',
    'fech_nac_vendedor',
    'fech_nac_comprador',
  ];

  // Estado original del atributo required capturado al iniciar
  var originalRequired = {};

  function captureOriginalRequired() {
    CAMPOS_CONDICIONALES.forEach(function (name) {
      var el = document.querySelector('[name="' + name + '"]');
      originalRequired[name] = el ? el.hasAttribute('required') : false;
    });
  }

  function setRequired(name, value) {
    var elements = document.querySelectorAll('[name="' + name + '"]');
    elements.forEach(function (el) {
        if (value) {
            el.setAttribute('required', 'required');
        } else {
            el.removeAttribute('required');
        }
    });
    setJFBRequired(name, value);
  }


  function getVehiculoSeleccionado() {
    // JFB Advanced Choice Field: el <li> seleccionado lleva la clase is-checked
    var checkedLi = document.querySelector(
      '.jet-form-builder-choice--item.is-checked [name="elegir_vehiculo"]'
    );
    if (checkedLi) return checkedLi.value;

    // Fallback: radio nativo con checked
    var radio = document.querySelector('[name="elegir_vehiculo"]:checked');
    return radio ? radio.value : null;
  }

  function isNoListadoChecked() {
    var cb = document.querySelector('[name="checkbox_veh_no_listado"]');
    return cb ? cb.checked : false;
  }

  function setFieldAsterisk(fieldName, visible) {
    var el = document.querySelector('[name="' + fieldName + '"]');
    if (!el) return;
    var wrapper = el.closest('.jet-form-builder-row');
    if (!wrapper) return;
    var asterisk = wrapper.querySelector('.jet-form-builder__required');
    if (!asterisk) return;
    asterisk.style.display = visible ? '' : 'none';
  }

  function setModeloCocheAsterisk(visible) {
    setFieldAsterisk('modelo_coche', visible);
  }

  function updateRequired() {
    var vehiculo  = getVehiculoSeleccionado();
    var noListado = isNoListadoChecked();

    // 1. Restaurar el required original de todos los campos condicionales
    CAMPOS_CONDICIONALES.forEach(function (name) {
      setRequired(name, originalRequired[name]);
    });

    // 2. Sin selección → todos los campos quedan como estaban (estado inicial)
    if (!vehiculo) {
      setModeloCocheAsterisk(true);
      return;
    }

    if (vehiculo === 'veh_coche') {
      // Campos de moto: no visibles → sin required
      setRequired('marca_moto',      false);
      setRequired('cilindrada_moto', false);

      if (noListado) {
        // Checkbox activo: modelo_coche oculto → sin required y ocultar asterisco
        setRequired('modelo_coche', false);
        setModeloCocheAsterisk(false);
        setRequired('modelo_vehiculo_no_listado',          originalRequired['modelo_vehiculo_no_listado']);
        setRequired('cilindrada_vehiculo_no_listado',      originalRequired['cilindrada_vehiculo_no_listado']);
        setRequired('potencia_fiscal_vehiculo_no_listado', originalRequired['potencia_fiscal_vehiculo_no_listado']);
      } else {
        // Checkbox inactivo: modelo_coche visible → restaurar asterisco
        setModeloCocheAsterisk(true);
        // Campos "no listado" ocultos → sin required
        setRequired('modelo_vehiculo_no_listado',          false);
        setRequired('cilindrada_vehiculo_no_listado',      false);
        setRequired('potencia_fiscal_vehiculo_no_listado', false);
      }

    } else if (vehiculo === 'veh_moto') {
      // Campos de coche: no visibles → sin required
      setRequired('marca_coche',        false);
      setRequired('modelo_coche',       false);
      setModeloCocheAsterisk(false);
      setRequired('tcombustible_coche', false);

      // Campos "vehículo no listado": solo visibles en veh_coche + checkbox → sin required
      setRequired('modelo_vehiculo_no_listado',         false);
      setRequired('cilindrada_vehiculo_no_listado',     false);
      setRequired('potencia_fiscal_vehiculo_no_listado', false);
    }
  }

  // Observa los <li> del Advanced Choice Field elegir_vehiculo
  // y dispara updateRequired cuando cambia la clase is-checked
  function watchVehiculoChoice() {
    var items = document.querySelectorAll('.jet-form-builder-choice--item');
    var found = false;

    items.forEach(function (li) {
      if (!li.querySelector('[name="elegir_vehiculo"]')) return;
      found = true;

      new MutationObserver(function (mutations) {
        mutations.forEach(function (mut) {
          if (mut.attributeName === 'class') {
            updateRequired();
          }
        });
      }).observe(li, { attributes: true });
    });

    return found;
  }

  // ---------------------------------------------------------------------------
  // Tipo fiscal vendedor / comprador → fecha de nacimiento no obligatoria
  // si el tipo fiscal es "Sociedad"
  // ---------------------------------------------------------------------------
  function getTFiscal(who) {
    var name = 'tfiscal_' + who;

    // Select nativo o input de texto
    var el = document.querySelector('[name="' + name + '"]');
    if (el && el.value) return el.value;

    // JFB Advanced Choice Field (radio dentro de .is-checked)
    var checkedLi = document.querySelector(
      '.jet-form-builder-choice--item.is-checked [name="' + name + '"]'
    );
    if (checkedLi) return checkedLi.value;

    // Fallback: radio nativo checked
    var radio = document.querySelector('[name="' + name + '"]:checked');
    return radio ? radio.value : '';
  }

  function updateFechaNacRequired() {
    var vendedorEsSociedad  = getTFiscal('vendedor')  === 'Sociedad';
    var compradorEsSociedad = getTFiscal('comprador') === 'Sociedad';
    var propietarioEsSociedad = getTFiscal('propietario') === 'Sociedad';

    setRequired('fech_nac_vendedor',  !vendedorEsSociedad  && !!originalRequired['fech_nac_vendedor']);
    setFieldAsterisk('fech_nac_vendedor',  !vendedorEsSociedad);

    setRequired('fech_nac_comprador', !compradorEsSociedad && !!originalRequired['fech_nac_comprador']);
    setFieldAsterisk('fech_nac_comprador', !compradorEsSociedad);

    setRequired('fech_nac_propietario', !propietarioEsSociedad && !!originalRequired['fech_nac_propietario']);
    setFieldAsterisk('fech_nac_propietario', !propietarioEsSociedad);
  }

  function init() {
    captureOriginalRequired();

    // Si JFB aún no ha renderizado los <li>, esperar con MutationObserver
    if (!watchVehiculoChoice()) {
      var bodyObs = new MutationObserver(function () {
        if (watchVehiculoChoice()) bodyObs.disconnect();
      });
      bodyObs.observe(document.body, { childList: true, subtree: true });
    }

    // Checkbox nativo: escuchar change en el documento (delegación)
    document.addEventListener('change', function (e) {
      if (e.target.name === 'checkbox_veh_no_listado') {
        updateRequired();
      }
      if (e.target.name === 'tfiscal_vendedor' || e.target.name === 'tfiscal_comprador') {
        updateFechaNacRequired();
      }
    });

    // JFB Advanced Choice Field: observar cambio de clase is-checked en los <li>
    // que contengan tfiscal_vendedor o tfiscal_comprador
    function watchTFiscalChoices() {
      var items = document.querySelectorAll('.jet-form-builder-choice--item');
      var found = false;
      items.forEach(function (li) {
        var inp = li.querySelector('[name="tfiscal_vendedor"], [name="tfiscal_comprador"]');
        if (!inp) return;
        found = true;
        new MutationObserver(function (mutations) {
          mutations.forEach(function (mut) {
            if (mut.attributeName === 'class') updateFechaNacRequired();
          });
        }).observe(li, { attributes: true });
      });
      return found;
    }

    if (!watchTFiscalChoices()) {
      var tfObs = new MutationObserver(function () {
        if (watchTFiscalChoices()) tfObs.disconnect();
      });
      tfObs.observe(document.body, { childList: true, subtree: true });
    }

    // Pasada inicial por si algo ya está seleccionado al cargar la página
    updateRequired();
    updateFechaNacRequired();

    // Re-aplica required justo antes de que JFB valide el paso siguiente
    watchNextButton();
  }

  function getJFBForm() {
    // Intenta localizar el formulario por distintos campos, de más específico a más genérico
    var anchors = [
      '[name="elegir_vehiculo"]',
      '[name="fech_nac_vendedor"]',
      '[name="fech_nac_comprador"]',
      '[name="fech_nac_propietario"]',
      'form.jet-form-builder',
    ];

    var formEl = null;
    for (var a = 0; a < anchors.length; a++) {
      var node = document.querySelector(anchors[a]);
      if (!node) continue;
      formEl = node.matches('form') ? node : node.closest('form');
      if (formEl) break;
    }

    if (!formEl) return null;

    var formId = formEl.getAttribute('data-form-id');
    if (!formId) return null;

    return (window.JetFormBuilder && window.JetFormBuilder[formId]) || null;
  }

  document.addEventListener('DOMContentLoaded', init);

  function setJFBRequired(name, value) {
    var jfbForm = getJFBForm();
    if (!jfbForm) return;

    var inp = jfbForm.dataInputs[name];
    if (!inp) return;

    inp.isRequired = value;
    if (inp.attrs) inp.attrs.required = value ? 'required' : false;

    // Neutralizar/restaurar la restriction con type='required' en reporting
    var restrictions = inp.reporting && inp.reporting.restrictions;
    if (restrictions) {
      for (var i = 0; i < restrictions.length; i++) {
        var r = restrictions[i];
        if (r.type !== 'required') continue;

        if (!value) {
          // Guardamos los métodos originales solo la primera vez
          if (!r._originalIsSupported) {
            r._originalIsSupported = r.isSupported.bind(r);
          }
          if (!r._originalValidate) {
            r._originalValidate = r.validate.bind(r);
          }
          // JFB no ejecutará esta restriction ni en isSupported ni en validate
          r.isSupported = function () { return false; };
          r.validate    = function () { return Promise.resolve([]); };
        } else {
          // Restauramos los métodos originales
          if (r._originalIsSupported) {
            r.isSupported = r._originalIsSupported;
          }
          if (r._originalValidate) {
            r.validate = r._originalValidate;
          }
        }
      }
    }

    // stopValidation=true hace que JFB omita completamente la validación del campo
    inp.stopValidation = !value;

    // Limpiar el estado de validez cacheado
    if (inp.reporting && inp.reporting.validityState) {
      inp.reporting.validityState.current = value ? null : true;
    }
  }

  // Intercepta botones de avance Y de envío final con captura (antes que JFB)
  function watchNextButton() {
    var form = document.querySelector('form.jet-form-builder');
    if (!form) return;

    form.addEventListener('click', function (e) {
      var btn = e.target.closest(
        '[data-jfb-action="go-next"], .jet-form-builder__next-page, .jfb-next-page, [class*="next"], [type="submit"], button:not([type="button"])'
      );
      if (!btn) return;
      updateRequired();
      updateFechaNacRequired();
    }, true); // useCapture: true → se ejecuta antes que los listeners de JFB

    // También interceptar el evento submit del formulario
    form.addEventListener('submit', function () {
      updateRequired();
      updateFechaNacRequired();
    }, true);
  }

})();



// WEBPACK FOOTER //
// ./scripts/formularios-itp/form-conditional-required.js